export default "__VITE_ASSET__e70addc7__"